import { GripHorizontal, Pencil, Trash } from 'lucide-react';
import Button from '../../../components/Button';
import type { OcdDetailsQuestionTemplate } from '../services/settingsTypes';

interface OcdDetailsQuestionRowProps {
    template: OcdDetailsQuestionTemplate;
    index: number;
    isDragging: boolean;
    onDragStart: (index: number) => void;
    onDragOver: (e: React.DragEvent, index: number) => void;
    onDragEnd: () => void;
    onEdit: (template: OcdDetailsQuestionTemplate) => void;
    onDelete: (template: OcdDetailsQuestionTemplate) => void;
}

export const OcdDetailsQuestionRow = ({
    template,
    index,
    isDragging,
    onDragStart,
    onDragOver,
    onDragEnd,
    onEdit,
    onDelete,
}: OcdDetailsQuestionRowProps) => {
    return (
        <div
            draggable
            onDragStart={() => onDragStart(index)}
            onDragOver={(e) => onDragOver(e, index)}
            onDragEnd={onDragEnd}
            className={`bg-white border border-gray-200 rounded-lg p-2 flex items-start justify-between hover:shadow-md transition-shadow cursor-move ${isDragging ? 'opacity-50' : ''
                }`}
        >
            <div className="flex items-start gap-4 flex-1 min-w-0">
                <div className="text-gray-400 mt-1">
                    <GripHorizontal size={16} />
                </div>
                <div className="flex-1 min-w-0">
                    <div className="font-medium text-gray-900 mb-1 break-words">
                        {template.questionTemplate}
                    </div>
                </div>
            </div>
            <div className="flex gap-2 ml-4">
                <Button
                    onClick={() => onEdit(template)}
                    size="sm"
                    icon={<Pencil size={16} />}
                />
                <Button
                    onClick={() => onDelete(template)}
                    variant="danger"
                    size="sm"
                    icon={<Trash size={16} />}
                />
            </div>
        </div>
    );
};

